import {
  cardConfig,
  featureSections,
} from "./providers/config/providersConfig";

import { Card } from "./providers/components/Card";
import { CoverageSection } from "./about/components/CoverageSection";
import { DMESection } from "./providers/components/DMESection";
import { FeatureSection } from "./components/sections/FeatureSection";
import { Footer } from "./footer/NewFooter";
import { Hero } from "./providers/components/Hero";
import ProviderNavigation from "../ProviderNavigation";
import { TestimonialSection } from "./new_home/components/TestimonialSection";
import { testimonials } from "./new_home/config/testimonials";

export default function ProvidersPage() {
  return (
    <div className="tw-relative tw-min-h-screen">
      <div className="tw-bg-[#010B70] tw-bg-[url('/landing_page_assets/backgrounds/bg2.jpg')] tw-bg-cover">
        <ProviderNavigation isDark />
        <div className="tw-relative tw-mx-auto tw-mt-[48px] tw-max-w-[1448px] tw-px-[20px] tw-pb-[64px]">
          <Hero />
        </div>
      </div>

      <div className="tw-relative tw-mx-auto tw-flex tw-h-full tw-w-full tw-max-w-[1448px] tw-flex-col tw-gap-y-[80px] tw-overflow-hidden tw-px-[20px] tw-py-[56px] min440:tw-gap-y-[120px] min440:tw-px-[76px]">
        <TestimonialSection testimonials={testimonials} />
        <img
          src="/landing_page_assets/payor_network_page/lightsquiggle.svg"
          className="tw-absolute tw-right-0 tw-top-[-100px] tw-z-0 tw-aspect-[2/1]"
        />
        <div className="tw-z-20 tw-flex tw-w-full tw-flex-col tw-gap-[2em] min440:tw-flex-row">
          {cardConfig.map((card, index) => (
            <Card key={`provider-card-${index}`} {...card} />
          ))}
        </div>
        {featureSections.map((section, index) => (
          <FeatureSection key={`feature-section-${index}`} {...section} />
        ))}
        <img
          src="/landing_page_assets/payor_network_page/lightsquiggle.svg"
          className="tw-absolute tw-bottom-0 tw-left-[100px] tw-z-0 tw-aspect-[2/1]"
        />
      </div>
      <CoverageSection
        title="Extensive payor & geographical coverage"
        descriptions={[
          "With Verse, providers no longer need to piece together a network of DMEs for different payors and delivery regions.",
          "Verse acts as a one-stop shop for your facility, serving patients across 49 states—including rural and underserved areas—and working with nearly every major payor.",
        ]}
      />
      <DMESection />
      <Footer
        title="Learn more about"
        titleAccent="Verse"
        description="Reach out to us to see if Verse might be a fit for your facility."
        isRounded
        hasSquiggle
      />
    </div>
  );
}
